/**
 * Methods used by the Calendar component
 */
export const DAYS_SHORTCUTS = ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa'];
export const DAYS_NAMES = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];

export function getMonthName(month) {
  return [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ][month];
}

export function createRange(start, end) {
  return Array.from({ length: end - start + 1 }, (x, i) => i + start);
}

export function transpose(array, offset) {
  const table = [...array];
  for (let i = 0; i < offset; i += 1) {
    table.push(table.shift());
  }
  return table;
}
